module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"unknow_error":"Algo deu errado, tente novamente em alguns instantes."},"en":{"unknow_error":"Something went wrong, try again in few seconds."}}')
  delete Component.options._Ctor
}
